import React from 'react';
import {
  Container,
} from 'react-bootstrap';
import PageHeader from '../../common/PageHeader';
import './Experience.css';

const OtherExperiences = () => (
  <>
    <PageHeader title="Other Experiences" />
    <Container className="experience-section others-page bg-light pt-3 pb-3">
      <hr/>
    </Container>
  </>
);

export default OtherExperiences;